<template>
  <header id="header" :class="[menuDisplay, {hide: hideMenu}]">

  	<div class="homepage-logos" :class="{display: (homepageHeader && slideIndex === 2)}">
  		<a href="http://www.ocgov.com/" target="_blank"><div class="hitbox"></div></a>
  		<a href="https://www.ocair.com/default" target="_blank"><div class="hitbox"></div></a>
  	</div>
  	<h1 class="barlow" :class="{display: !homepageHeader, white: whiteHeader}" v-on:click="goHome">JOHN WAYNE AIRPORT <span>2018 ANNUAL REPORT</span></h1>

  	<div class="menu-btn" :class="{black: menuColor}" v-on:click="openMenu">
  		<span class="barlow menu" :class="menuDisplay">{{menuDisplay}}</span>
  		<div class="menu-icon" :class="menuDisplay">
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</div>
  	</div>
  	
  </header>
</template>

<script>
  export default {
    name: 'mainHeader',
    props: {
    	showMenu: Boolean,
    	toggleMenu: Function,
    	changeSlide: Function,
    	slideIndex: Number,
    	viewIndex: Number
    },
    methods: {
	  	openMenu: function() {
	  		this.$emit('toggleMenu');
	  	},
	  	newSlide: function() {
	  		this.$emit('changeSlide', this.slideIndex + 1)
	  	},
	  	goHome: function(){
	  		this.$emit('changeView', 0)
	  	}
	},
	computed: {
		menuDisplay: function() {
			return this.showMenu ? 'close' : 'menu';
		},
		menuColor: function() {
			return (this.slideIndex === 1 && this.viewIndex === 4)
		},
		homepageHeader: function() {
			return (this.viewIndex === 0)
		},
		hideMenu: function() {
			let { slideIndex, viewIndex } = this
			return (viewIndex === 0 && (slideIndex === 0 || slideIndex === 1))
		},
		whiteHeader: function() {
			let { viewIndex, slideIndex } = this
			return (
				(viewIndex == 1 && slideIndex == 5) ||
				(viewIndex == 2 && (slideIndex == 0 || slideIndex == 1 || slideIndex == 4 || slideIndex == 6)) ||
				(viewIndex == 3 && (slideIndex == 0 || slideIndex == 3 || slideIndex == 7)) || 
				(viewIndex == 5 && (slideIndex == 0))
			)
		}

	}
  } 
</script>

<style lang="scss">
	@import '../sass/variables';

	.menu-icon{
			width: 20px;
			height: 14px;
			position: relative;
			transform: rotate(0deg);
			transition: 400ms ease-out;
			span{
				display: block;
				position: absolute;
				height: 2px;
				width: 100%;
				background: #fff;
				opacity: 1;
				left: 0;
				transform: rotate(0deg);
				transition: 300ms ease-out;
				&:nth-child(1){ top: 0;  width: 52%;}
				&:nth-child(2), &:nth-child(3){ top: calc(50% - 1px); }
				&:nth-child(4){ bottom: 0%; width: 80%; }
			}
			&.close{
				span{
					background: #fff!important;
					&:nth-child(1){ 
						top: 50%;
						width: 0%!important;
						left: 50%;
					}
					&:nth-child(2){
						transform: rotate(45deg);	
					}
					&:nth-child(3){
						transform: rotate(-45deg);
					}
					&:nth-child(4){
						bottom: 50%;
						width: 0%!important;
						left: 50%;
					}
				}
			}
		}
		
	#header{
		position: absolute;
		width: 100%;
		display: flex;
		justify-content: space-between;
		z-index: 9;
		transition: transform 300ms ease-out;
		&.offscreen{
			transform: translate(0,-100%);
		}
		@include vw-pixels((
          'padding': 32
        ));
        &.hide{
			opacity: 0;
			pointer-events: none;
		}
        h1{
        	cursor: pointer;
        	color: $maroon;
        	span{
        		font-weight: 500;
        		letter-spacing: 0;
        		@media #{$phoneQuery}{
        			display: block;
        		}
        	}
        	opacity: 0;
        	pointer-events: none;
        	transition: opacity 400ms ease-out, color 400ms ease-out;
        	&.display{
        		opacity: 1;
	        	pointer-events: auto;
        	}
        	&.white{
        		color: #fff;
        	}
        }
		.homepage-logos{
			opacity: 0;
			pointer-events: none;
			position: absolute;
			background-image: url('../assets/images/home-header-logos.svg');
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center top;
			transition: opacity 400ms ease-out;
			display: flex;
			@include vw-units((
	          'width': 9.88,
	          'height':5.85,
	          'margin-top': -0.64
	        ));
	        &.display{
	        	opacity: 1;
	        	pointer-events: auto;
	        }
	        > *{
	        	height: 100%;
	        	width: 50%;
	        }
		}

		.menu-btn{
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			transition: opacity 300ms ease-out;
			span.menu{
				letter-spacing: 0.16em;
				margin-right: 4px;
				color: #fff;
				transition: color 300ms ease-out;
				&.close{
					color: #fff!important;
				}
			}
			&:hover{
				.menu-icon{
					span{
						width: 100%;
					}
				}
			}
			&.black{
				span.menu{
					color: #000;
				}
				.menu-icon{
					span{
						background: #000;
					}
				}
			}
		}
		&.close{
			h1{
				opacity: 0;
			}
			.homepage-logos{
				opacity: 0;
			}
		}
	}

	.borderedTwoColumn, .bgImageTwoColumn{
		#header{
			.menu-btn span{
				color: #000;
			}
			.menu-icon span{
				background: #000;
			}
		}
	}
</style>
